











import InfoBox from '@/components/InfoBox'

export default {
    name: 'InfoBoxes'

    components:
        InfoBox: InfoBox

    props: ['document']

    computed:
        isScreenWidth: -> @fields.width is 'Bildschirm'
        isPageWidth: -> @fields.width is 'Seite'

    data: ->
        fields: @defaultFields()

    methods:
        defaultFields: ->
            width: 'Bildschirm'
            boxes: []

        setContent: (document) ->
            fields = 
                width: document.primary.width
                boxes: document.items
            $.extend @fields, fields

    created: ->
        @setContent @document
}
